var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnreadUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4287 11.0714L5.57157 6.21428L0.714423 11.0714",
    stroke: "url(#paint0_linear_7022_32412)",
    strokeWidth: 1.45714
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4287 6.21428L5.57157 1.35713L0.714423 6.21428",
    stroke: "url(#paint1_linear_7022_32412)",
    strokeWidth: 1.45714
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7022_32412",
    x1: 10.1106,
    y1: 6.35581,
    x2: 0.962432,
    y2: 6.35581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7022_32412",
    x1: 10.1106,
    y1: 1.49867,
    x2: 0.962432,
    y2: 1.49867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadUp);
export default __webpack_public_path__ + "static/media/unread_up.8b6d2bccf99195285d20f2d92f7b42c8.svg";
export { ForwardRef as ReactComponent };